import React, { useEffect } from 'react'
import {
    Box,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerOverlay,
    Image,
    Stack,
    useBreakpointValue,
    useColorMode,
} from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import JGoogleIcon from '../JGoogleIcon/JGoogleIcon'
import TeamInformation from './components/TeamInformation'
import Version from './components/Version'
import Modules from './components/Modules'
import { IL_STARTS } from '../../assets'
import { sidebarSlice, teamSliceV2 } from '../../redux'

const Sidebar = () => {
    const dispatch = useDispatch<any>()
    const { colorMode } = useColorMode()
    const isDesktop = useBreakpointValue({ base: false, md: true })

    const BACKGROUND_COLOR: any = {
        'Default': '#017ad2',
        'Grey-vis': '#f0f4fb',
        'Green-vis': '#96c45e',
        'Yellow-vis': '#f1b801',
        'Red-vis': '#e03d3d',
    }

    const teamV2: any = useSelector((state: any) => state?.teamV2)
    const sidebar = useSelector((state: any) => state?.sidebar)

    const backgroundColor = colorMode === 'dark'
        ? 'surfacePlus1'
        : teamV2?.detail?.theme_object
            ? BACKGROUND_COLOR[teamV2?.detail?.theme_object?.code]
            : 'primary'

    useEffect(() => {
        if (isDesktop !== undefined) {
            dispatch(sidebarSlice.setSidebarReveal(isDesktop))
        }
        dispatch(teamSliceV2?.getTeamDetailAction())
    }, [dispatch, isDesktop])

    const SidebarContent = (
        <Stack
            width={sidebar?.isReveal ? '248px' : '84px'}
            backgroundColor={backgroundColor}
            transition='width 0.3s ease-in-out'
            height='100vh'
            overflowY='auto'
            paddingY='16px'
            position='relative'
            zIndex={999}
        >
            <Stack position='relative' gap='24px'>
                <Image
                    src={IL_STARTS}
                    position='absolute'
                    top='0px'
                    left='0px'
                    right='0px'
                    objectFit='cover'
                    marginTop='auto'
                    zIndex='0'
                />
                <JGoogleIcon
                    name='menu'
                    marginX='var(--sidebarPadding) !important'
                    cursor='pointer'
                    color={colorMode === 'light'
                        ? teamV2?.detail?.theme_object?.code === 'Grey-vis' ? 'black' : '#FDFCFF'
                        : 'unset'}
                    onClick={() => {
                        if (!isDesktop) {
                            dispatch(sidebarSlice.sidebarReveal())
                        } else {
                            dispatch(sidebarSlice.sidebarReveal())
                        }
                    }}
                    position='relative'
                    zIndex={1}
                />
                <Box paddingX='16px'>
                    <TeamInformation />
                </Box>
                <Modules />
                {sidebar?.isReveal && <Version />}
            </Stack>
        </Stack>
    )

    return (
        <>
            {isDesktop ? (
                <Stack
                    width={sidebar?.isReveal ? '248px' : '84px'}
                    transition='width 0.3s ease-in-out'
                    backgroundColor={backgroundColor}
                    overflowY='auto'
                    paddingY='16px'
                    position='relative'
                    zIndex={999}
                >
                    {SidebarContent}
                </Stack>
            ) : (
                <Drawer
                    isOpen={sidebar?.isReveal}
                    placement="left"
                    onClose={() => dispatch(sidebarSlice.sidebarReveal())}
                >
                    <DrawerOverlay />
                    <DrawerContent bg={backgroundColor} maxW="248px">
                        <DrawerBody padding={0}>
                            {SidebarContent}
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
            )}
        </>
    )
}

export default React.memo(Sidebar)
